import request from '@/utils/request'
const apiPath = '/order/OrderPerformance'
import { downloadBlob } from '@/utils/download'
const OrderPerformanceApi = {
  /**
   * 新增【大区业绩列表】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【大区业绩列表】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【大区业绩列表】
   */
  performanceList(data) {
    return request.post(apiPath + '/performanceList', data)
  },
  orderPerformanceExport(data) {
    return request.post(apiPath + '/orderPerformanceExport', data)
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【大区业绩列表】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【大区业绩列表】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '大区业绩列表.xlsx'))
  },
}
export default OrderPerformanceApi
